/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as LogoutRouteImport } from './../routes/logout'
import { Route as ConnectRouteImport } from './../routes/connect'
import { Route as AdminRouteRouteImport } from './../routes/admin/route'
import { Route as orgRouteRouteImport } from './../routes/(org)/route'
import { Route as legacyRouteRouteImport } from './../routes/(legacy)/route'
import { Route as authRouteRouteImport } from './../routes/(auth)/route'
import { Route as appRouteRouteImport } from './../routes/(app)/route'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as AdminIndexRouteImport } from './../routes/admin/index'
import { Route as ProfilesVerifyEmailRouteImport } from './../routes/profiles/verify-email'
import { Route as ProfilesClaimConfirmRouteImport } from './../routes/profiles/claim-confirm'
import { Route as PortfolioProfileSlugRouteImport } from './../routes/portfolio/$profileSlug'
import { Route as P2ProfileSlugRouteImport } from './../routes/p2/$profileSlug'
import { Route as PProfileSlugRouteImport } from './../routes/p/$profileSlug'
import { Route as OrderRequestsKeyRouteImport } from './../routes/orderRequests.$key'
import { Route as OauthCallbackRouteImport } from './../routes/oauth/callback'
import { Route as InvitationsAcceptRouteImport } from './../routes/invitations/accept'
import { Route as AdminUsersRouteImport } from './../routes/admin/users'
import { Route as AdminProfilesRouteImport } from './../routes/admin/profiles'
import { Route as AdminJobsRouteImport } from './../routes/admin/jobs'
import { Route as AdminFeatureFlagsRouteImport } from './../routes/admin/feature-flags'
import { Route as AdminAccountsRouteImport } from './../routes/admin/accounts'
import { Route as AccessRequestsRejectRouteImport } from './../routes/access-requests/reject'
import { Route as AccessRequestsApproveRouteImport } from './../routes/access-requests/approve'
import { Route as authSelectRoleRouteImport } from './../routes/(auth)/select-role'
import { Route as authLoginRouteImport } from './../routes/(auth)/login'
import { Route as authJoinRouteImport } from './../routes/(auth)/join'
import { Route as appExamplesRouteRouteImport } from './../routes/(app)/examples/route'
import { Route as appExamplesIndexRouteImport } from './../routes/(app)/examples/index'
import { Route as legacyProgramsProgramIdRouteImport } from './../routes/(legacy)/programs/$programId'
import { Route as legacyOffersTokenRouteImport } from './../routes/(legacy)/offers.$token'
import { Route as legacyBrandsClientIdRouteImport } from './../routes/(legacy)/brands.$clientId'
import { Route as appExamplesUsersRouteImport } from './../routes/(app)/examples/users'
import { Route as appExamplesReportsRouteImport } from './../routes/(app)/examples/reports'
import { Route as appExamplesDashboardRouteImport } from './../routes/(app)/examples/dashboard'
import { Route as appExamplesAnalyticsRouteImport } from './../routes/(app)/examples/analytics'
import { Route as appExamplesAboutRouteImport } from './../routes/(app)/examples/about'
import { Route as orgOOrgSlugRouteRouteImport } from './../routes/(org)/o.$orgSlug/route'
import { Route as orgOOrgSlugIndexRouteImport } from './../routes/(org)/o.$orgSlug/index'
import { Route as orgOOrgSlugToolkitRouteImport } from './../routes/(org)/o.$orgSlug/toolkit'
import { Route as orgOOrgSlugSettingsRouteImport } from './../routes/(org)/o.$orgSlug/settings'
import { Route as orgOOrgSlugSelectRoleRouteImport } from './../routes/(org)/o.$orgSlug/select-role'
import { Route as orgOOrgSlugOnboardingRouteImport } from './../routes/(org)/o.$orgSlug/onboarding'
import { Route as orgOOrgSlugMembersRouteImport } from './../routes/(org)/o.$orgSlug/members'
import { Route as orgOOrgSlugMarketplaceRouteImport } from './../routes/(org)/o.$orgSlug/marketplace'
import { Route as orgOOrgSlugEarningsRouteImport } from './../routes/(org)/o.$orgSlug/earnings'
import { Route as orgOOrgSlugDashboardRouteImport } from './../routes/(org)/o.$orgSlug/dashboard'
import { Route as orgOOrgSlugConnectRouteImport } from './../routes/(org)/o.$orgSlug/connect'
import { Route as appRBrandClientIdRouteImport } from './../routes/(app)/r.brand.$clientId'
import { Route as legacyCreatorsProgramsProgramIdRouteRouteImport } from './../routes/(legacy)/creators/programs/$programId/route'
import { Route as orgOOrgSlugProjectsIndexRouteImport } from './../routes/(org)/o.$orgSlug/projects/index'
import { Route as orgOOrgSlugProfilesIndexRouteImport } from './../routes/(org)/o.$orgSlug/profiles/index'
import { Route as orgOOrgSlugOffersIndexRouteImport } from './../routes/(org)/o.$orgSlug/offers.index'
import { Route as orgOOrgSlugUserSettingsRouteImport } from './../routes/(org)/o.$orgSlug/user/settings'
import { Route as orgOOrgSlugUserNotificationsRouteImport } from './../routes/(org)/o.$orgSlug/user/notifications'
import { Route as orgOOrgSlugToolkitPreviewRouteImport } from './../routes/(org)/o.$orgSlug/toolkit_.preview'
import { Route as orgOOrgSlugOffersOfferIdRouteImport } from './../routes/(org)/o.$orgSlug/offers.$offerId'
import { Route as orgOOrgSlugOauthCallbackRouteImport } from './../routes/(org)/o.$orgSlug/oauth/callback'
import { Route as legacyCreatorsProgramsProgramIdDirectRouteImport } from './../routes/(legacy)/creators/programs/$programId/direct'
import { Route as orgOOrgSlugProjectsProjectIdRouteRouteImport } from './../routes/(org)/o.$orgSlug/projects/$projectId/route'
import { Route as orgOOrgSlugProfilesProfileSlugRouteRouteImport } from './../routes/(org)/o.$orgSlug/profiles/$profileSlug/route'
import { Route as orgOOrgSlugPProfileSlugRouteRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/route'
import { Route as orgOOrgSlugProfilesProfileSlugIndexRouteImport } from './../routes/(org)/o.$orgSlug/profiles/$profileSlug/index'
import { Route as orgOOrgSlugOffersOfferIdIndexRouteImport } from './../routes/(org)/o.$orgSlug/offers.$offerId.index'
import { Route as orgOOrgSlugOffersOfferIdCustomizeLandingRouteImport } from './../routes/(org)/o.$orgSlug/offers.$offerId.customize-landing'
import { Route as orgOOrgSlugOffersOfferIdBoostProductSelectionRouteImport } from './../routes/(org)/o.$orgSlug/offers.$offerId/boost-product-selection'
import { Route as legacyCreatorsProgramsProgramIdInteractionInteractionIdRouteImport } from './../routes/(legacy)/creators/programs/$programId/interaction.$interactionId'
import { Route as legacyCreatorsProgramsProgramIdContentContentIdRouteImport } from './../routes/(legacy)/creators/programs/$programId/content.$contentId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdRouteRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/route'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdIndexRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/index'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/submit-content.$interactionId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/sign-brief.$interactionId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/promo-codes.$interactionId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/product-selection.$interactionId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/customize-landing.$interactionId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/custom-task.$stageId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/confirm-info.$interactionId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/boost-product-selection.$interactionId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/affiliate-links.$interactionId'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/submit-content.$interactionId.index'
import { Route as orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRouteImport } from './../routes/(org)/o.$orgSlug/p.$profileSlug/c.$campaignId/submit-content.$interactionId.$contentReviewId'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const orgRouteRoute = orgRouteRouteImport.update({
  id: '/(org)',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyRouteRoute = legacyRouteRouteImport.update({
  id: '/(legacy)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ProfilesVerifyEmailRoute = ProfilesVerifyEmailRouteImport.update({
  id: '/profiles/verify-email',
  path: '/profiles/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilesClaimConfirmRoute = ProfilesClaimConfirmRouteImport.update({
  id: '/profiles/claim-confirm',
  path: '/profiles/claim-confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioProfileSlugRoute = PortfolioProfileSlugRouteImport.update({
  id: '/portfolio/$profileSlug',
  path: '/portfolio/$profileSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const P2ProfileSlugRoute = P2ProfileSlugRouteImport.update({
  id: '/p2/$profileSlug',
  path: '/p2/$profileSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const PProfileSlugRoute = PProfileSlugRouteImport.update({
  id: '/p/$profileSlug',
  path: '/p/$profileSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderRequestsKeyRoute = OrderRequestsKeyRouteImport.update({
  id: '/orderRequests/$key',
  path: '/orderRequests/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthCallbackRoute = OauthCallbackRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
  id: '/invitations/accept',
  path: '/invitations/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProfilesRoute = AdminProfilesRouteImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminJobsRoute = AdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccountsRoute = AdminAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AccessRequestsRejectRoute = AccessRequestsRejectRouteImport.update({
  id: '/access-requests/reject',
  path: '/access-requests/reject',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessRequestsApproveRoute = AccessRequestsApproveRouteImport.update({
  id: '/access-requests/approve',
  path: '/access-requests/approve',
  getParentRoute: () => rootRouteImport,
} as any)
const authSelectRoleRoute = authSelectRoleRouteImport.update({
  id: '/select-role',
  path: '/select-role',
  getParentRoute: () => authRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authJoinRoute = authJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => authRouteRoute,
} as any)
const appExamplesRouteRoute = appExamplesRouteRouteImport.update({
  id: '/examples',
  path: '/examples',
  getParentRoute: () => appRouteRoute,
} as any)
const appExamplesIndexRoute = appExamplesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appExamplesRouteRoute,
} as any)
const legacyProgramsProgramIdRoute = legacyProgramsProgramIdRouteImport.update({
  id: '/programs/$programId',
  path: '/programs/$programId',
  getParentRoute: () => legacyRouteRoute,
} as any)
const legacyOffersTokenRoute = legacyOffersTokenRouteImport.update({
  id: '/offers/$token',
  path: '/offers/$token',
  getParentRoute: () => legacyRouteRoute,
} as any)
const legacyBrandsClientIdRoute = legacyBrandsClientIdRouteImport.update({
  id: '/brands/$clientId',
  path: '/brands/$clientId',
  getParentRoute: () => legacyRouteRoute,
} as any)
const appExamplesUsersRoute = appExamplesUsersRouteImport
  .update({
    id: '/users',
    path: '/users',
    getParentRoute: () => appExamplesRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(app)/examples/users.lazy').then((d) => d.Route),
  )
const appExamplesReportsRoute = appExamplesReportsRouteImport
  .update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => appExamplesRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(app)/examples/reports.lazy').then((d) => d.Route),
  )
const appExamplesDashboardRoute = appExamplesDashboardRouteImport
  .update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => appExamplesRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(app)/examples/dashboard.lazy').then((d) => d.Route),
  )
const appExamplesAnalyticsRoute = appExamplesAnalyticsRouteImport
  .update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => appExamplesRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(app)/examples/analytics.lazy').then((d) => d.Route),
  )
const appExamplesAboutRoute = appExamplesAboutRouteImport
  .update({
    id: '/about',
    path: '/about',
    getParentRoute: () => appExamplesRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(app)/examples/about.lazy').then((d) => d.Route),
  )
const orgOOrgSlugRouteRoute = orgOOrgSlugRouteRouteImport.update({
  id: '/o/$orgSlug',
  path: '/o/$orgSlug',
  getParentRoute: () => orgRouteRoute,
} as any)
const orgOOrgSlugIndexRoute = orgOOrgSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => orgOOrgSlugRouteRoute,
} as any)
const orgOOrgSlugToolkitRoute = orgOOrgSlugToolkitRouteImport.update({
  id: '/toolkit',
  path: '/toolkit',
  getParentRoute: () => orgOOrgSlugRouteRoute,
} as any)
const orgOOrgSlugSettingsRoute = orgOOrgSlugSettingsRouteImport
  .update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(org)/o.$orgSlug/settings.lazy').then((d) => d.Route),
  )
const orgOOrgSlugSelectRoleRoute = orgOOrgSlugSelectRoleRouteImport.update({
  id: '/select-role',
  path: '/select-role',
  getParentRoute: () => orgOOrgSlugRouteRoute,
} as any)
const orgOOrgSlugOnboardingRoute = orgOOrgSlugOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => orgOOrgSlugRouteRoute,
} as any)
const orgOOrgSlugMembersRoute = orgOOrgSlugMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => orgOOrgSlugRouteRoute,
} as any)
const orgOOrgSlugMarketplaceRoute = orgOOrgSlugMarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => orgOOrgSlugRouteRoute,
} as any)
const orgOOrgSlugEarningsRoute = orgOOrgSlugEarningsRouteImport
  .update({
    id: '/earnings',
    path: '/earnings',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(org)/o.$orgSlug/earnings.lazy').then((d) => d.Route),
  )
const orgOOrgSlugDashboardRoute = orgOOrgSlugDashboardRouteImport
  .update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(org)/o.$orgSlug/dashboard.lazy').then((d) => d.Route),
  )
const orgOOrgSlugConnectRoute = orgOOrgSlugConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => orgOOrgSlugRouteRoute,
} as any)
const appRBrandClientIdRoute = appRBrandClientIdRouteImport.update({
  id: '/r/brand/$clientId',
  path: '/r/brand/$clientId',
  getParentRoute: () => appRouteRoute,
} as any)
const legacyCreatorsProgramsProgramIdRouteRoute =
  legacyCreatorsProgramsProgramIdRouteRouteImport.update({
    id: '/creators/programs/$programId',
    path: '/creators/programs/$programId',
    getParentRoute: () => legacyRouteRoute,
  } as any)
const orgOOrgSlugProjectsIndexRoute =
  orgOOrgSlugProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const orgOOrgSlugProfilesIndexRoute =
  orgOOrgSlugProfilesIndexRouteImport.update({
    id: '/profiles/',
    path: '/profiles/',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const orgOOrgSlugOffersIndexRoute = orgOOrgSlugOffersIndexRouteImport.update({
  id: '/offers/',
  path: '/offers/',
  getParentRoute: () => orgOOrgSlugRouteRoute,
} as any)
const orgOOrgSlugUserSettingsRoute = orgOOrgSlugUserSettingsRouteImport
  .update({
    id: '/user/settings',
    path: '/user/settings',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
  .lazy(() =>
    import('./../routes/(org)/o.$orgSlug/user/settings.lazy').then(
      (d) => d.Route,
    ),
  )
const orgOOrgSlugUserNotificationsRoute =
  orgOOrgSlugUserNotificationsRouteImport.update({
    id: '/user/notifications',
    path: '/user/notifications',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const orgOOrgSlugToolkitPreviewRoute =
  orgOOrgSlugToolkitPreviewRouteImport.update({
    id: '/toolkit_/preview',
    path: '/toolkit/preview',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const orgOOrgSlugOffersOfferIdRoute =
  orgOOrgSlugOffersOfferIdRouteImport.update({
    id: '/offers/$offerId',
    path: '/offers/$offerId',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const orgOOrgSlugOauthCallbackRoute =
  orgOOrgSlugOauthCallbackRouteImport.update({
    id: '/oauth/callback',
    path: '/oauth/callback',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const legacyCreatorsProgramsProgramIdDirectRoute =
  legacyCreatorsProgramsProgramIdDirectRouteImport.update({
    id: '/direct',
    path: '/direct',
    getParentRoute: () => legacyCreatorsProgramsProgramIdRouteRoute,
  } as any)
const orgOOrgSlugProjectsProjectIdRouteRoute =
  orgOOrgSlugProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const orgOOrgSlugProfilesProfileSlugRouteRoute =
  orgOOrgSlugProfilesProfileSlugRouteRouteImport.update({
    id: '/profiles/$profileSlug',
    path: '/profiles/$profileSlug',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const orgOOrgSlugPProfileSlugRouteRoute =
  orgOOrgSlugPProfileSlugRouteRouteImport.update({
    id: '/p/$profileSlug',
    path: '/p/$profileSlug',
    getParentRoute: () => orgOOrgSlugRouteRoute,
  } as any)
const orgOOrgSlugProfilesProfileSlugIndexRoute =
  orgOOrgSlugProfilesProfileSlugIndexRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => orgOOrgSlugProfilesProfileSlugRouteRoute,
    } as any)
    .lazy(() =>
      import('./../routes/(org)/o.$orgSlug/profiles/$profileSlug/index.lazy').then(
        (d) => d.Route,
      ),
    )
const orgOOrgSlugOffersOfferIdIndexRoute =
  orgOOrgSlugOffersOfferIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => orgOOrgSlugOffersOfferIdRoute,
  } as any)
const orgOOrgSlugOffersOfferIdCustomizeLandingRoute =
  orgOOrgSlugOffersOfferIdCustomizeLandingRouteImport.update({
    id: '/customize-landing',
    path: '/customize-landing',
    getParentRoute: () => orgOOrgSlugOffersOfferIdRoute,
  } as any)
const orgOOrgSlugOffersOfferIdBoostProductSelectionRoute =
  orgOOrgSlugOffersOfferIdBoostProductSelectionRouteImport.update({
    id: '/boost-product-selection',
    path: '/boost-product-selection',
    getParentRoute: () => orgOOrgSlugOffersOfferIdRoute,
  } as any)
const legacyCreatorsProgramsProgramIdInteractionInteractionIdRoute =
  legacyCreatorsProgramsProgramIdInteractionInteractionIdRouteImport.update({
    id: '/interaction/$interactionId',
    path: '/interaction/$interactionId',
    getParentRoute: () => legacyCreatorsProgramsProgramIdRouteRoute,
  } as any)
const legacyCreatorsProgramsProgramIdContentContentIdRoute =
  legacyCreatorsProgramsProgramIdContentContentIdRouteImport.update({
    id: '/content/$contentId',
    path: '/content/$contentId',
    getParentRoute: () => legacyCreatorsProgramsProgramIdRouteRoute,
  } as any)
const orgOOrgSlugPProfileSlugCCampaignIdRouteRoute =
  orgOOrgSlugPProfileSlugCCampaignIdRouteRouteImport.update({
    id: '/c/$campaignId',
    path: '/c/$campaignId',
    getParentRoute: () => orgOOrgSlugPProfileSlugRouteRoute,
  } as any)
const orgOOrgSlugPProfileSlugCCampaignIdIndexRoute =
  orgOOrgSlugPProfileSlugCCampaignIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
  } as any)
const orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteImport.update(
    {
      id: '/submit-content/$interactionId',
      path: '/submit-content/$interactionId',
      getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
    } as any,
  )
const orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRouteImport.update({
    id: '/sign-brief/$interactionId',
    path: '/sign-brief/$interactionId',
    getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
  } as any)
const orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRouteImport.update({
    id: '/promo-codes/$interactionId',
    path: '/promo-codes/$interactionId',
    getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
  } as any)
const orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRouteImport.update(
    {
      id: '/product-selection/$interactionId',
      path: '/product-selection/$interactionId',
      getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
    } as any,
  )
const orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRouteImport.update(
    {
      id: '/customize-landing/$interactionId',
      path: '/customize-landing/$interactionId',
      getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
    } as any,
  )
const orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRouteImport.update({
    id: '/custom-task/$stageId',
    path: '/custom-task/$stageId',
    getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
  } as any)
const orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRouteImport.update({
    id: '/confirm-info/$interactionId',
    path: '/confirm-info/$interactionId',
    getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
  } as any)
const orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRouteImport.update(
    {
      id: '/boost-product-selection/$interactionId',
      path: '/boost-product-selection/$interactionId',
      getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
    } as any,
  )
const orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRouteImport.update(
    {
      id: '/affiliate-links/$interactionId',
      path: '/affiliate-links/$interactionId',
      getParentRoute: () => orgOOrgSlugPProfileSlugCCampaignIdRouteRoute,
    } as any,
  )
const orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRoute =
  orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRoute,
    } as any,
  )
const orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRoute =
  orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRouteImport.update(
    {
      id: '/$contentReviewId',
      path: '/$contentReviewId',
      getParentRoute: () =>
        orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/connect': typeof ConnectRoute
  '/logout': typeof LogoutRoute
  '/examples': typeof appExamplesRouteRouteWithChildren
  '/join': typeof authJoinRoute
  '/login': typeof authLoginRoute
  '/select-role': typeof authSelectRoleRoute
  '/access-requests/approve': typeof AccessRequestsApproveRoute
  '/access-requests/reject': typeof AccessRequestsRejectRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/profiles': typeof AdminProfilesRoute
  '/admin/users': typeof AdminUsersRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/orderRequests/$key': typeof OrderRequestsKeyRoute
  '/p/$profileSlug': typeof PProfileSlugRoute
  '/p2/$profileSlug': typeof P2ProfileSlugRoute
  '/portfolio/$profileSlug': typeof PortfolioProfileSlugRoute
  '/profiles/claim-confirm': typeof ProfilesClaimConfirmRoute
  '/profiles/verify-email': typeof ProfilesVerifyEmailRoute
  '/admin/': typeof AdminIndexRoute
  '/o/$orgSlug': typeof orgOOrgSlugRouteRouteWithChildren
  '/examples/about': typeof appExamplesAboutRoute
  '/examples/analytics': typeof appExamplesAnalyticsRoute
  '/examples/dashboard': typeof appExamplesDashboardRoute
  '/examples/reports': typeof appExamplesReportsRoute
  '/examples/users': typeof appExamplesUsersRoute
  '/brands/$clientId': typeof legacyBrandsClientIdRoute
  '/offers/$token': typeof legacyOffersTokenRoute
  '/programs/$programId': typeof legacyProgramsProgramIdRoute
  '/examples/': typeof appExamplesIndexRoute
  '/creators/programs/$programId': typeof legacyCreatorsProgramsProgramIdRouteRouteWithChildren
  '/r/brand/$clientId': typeof appRBrandClientIdRoute
  '/o/$orgSlug/connect': typeof orgOOrgSlugConnectRoute
  '/o/$orgSlug/dashboard': typeof orgOOrgSlugDashboardRoute
  '/o/$orgSlug/earnings': typeof orgOOrgSlugEarningsRoute
  '/o/$orgSlug/marketplace': typeof orgOOrgSlugMarketplaceRoute
  '/o/$orgSlug/members': typeof orgOOrgSlugMembersRoute
  '/o/$orgSlug/onboarding': typeof orgOOrgSlugOnboardingRoute
  '/o/$orgSlug/select-role': typeof orgOOrgSlugSelectRoleRoute
  '/o/$orgSlug/settings': typeof orgOOrgSlugSettingsRoute
  '/o/$orgSlug/toolkit': typeof orgOOrgSlugToolkitRoute
  '/o/$orgSlug/': typeof orgOOrgSlugIndexRoute
  '/o/$orgSlug/p/$profileSlug': typeof orgOOrgSlugPProfileSlugRouteRouteWithChildren
  '/o/$orgSlug/profiles/$profileSlug': typeof orgOOrgSlugProfilesProfileSlugRouteRouteWithChildren
  '/o/$orgSlug/projects/$projectId': typeof orgOOrgSlugProjectsProjectIdRouteRoute
  '/creators/programs/$programId/direct': typeof legacyCreatorsProgramsProgramIdDirectRoute
  '/o/$orgSlug/oauth/callback': typeof orgOOrgSlugOauthCallbackRoute
  '/o/$orgSlug/offers/$offerId': typeof orgOOrgSlugOffersOfferIdRouteWithChildren
  '/o/$orgSlug/toolkit/preview': typeof orgOOrgSlugToolkitPreviewRoute
  '/o/$orgSlug/user/notifications': typeof orgOOrgSlugUserNotificationsRoute
  '/o/$orgSlug/user/settings': typeof orgOOrgSlugUserSettingsRoute
  '/o/$orgSlug/offers/': typeof orgOOrgSlugOffersIndexRoute
  '/o/$orgSlug/profiles/': typeof orgOOrgSlugProfilesIndexRoute
  '/o/$orgSlug/projects/': typeof orgOOrgSlugProjectsIndexRoute
  '/creators/programs/$programId/content/$contentId': typeof legacyCreatorsProgramsProgramIdContentContentIdRoute
  '/creators/programs/$programId/interaction/$interactionId': typeof legacyCreatorsProgramsProgramIdInteractionInteractionIdRoute
  '/o/$orgSlug/offers/$offerId/boost-product-selection': typeof orgOOrgSlugOffersOfferIdBoostProductSelectionRoute
  '/o/$orgSlug/offers/$offerId/customize-landing': typeof orgOOrgSlugOffersOfferIdCustomizeLandingRoute
  '/o/$orgSlug/offers/$offerId/': typeof orgOOrgSlugOffersOfferIdIndexRoute
  '/o/$orgSlug/profiles/$profileSlug/': typeof orgOOrgSlugProfilesProfileSlugIndexRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId': typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRouteWithChildren
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/': typeof orgOOrgSlugPProfileSlugCCampaignIdIndexRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId': typeof orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteWithChildren
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId': typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/': typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/logout': typeof LogoutRoute
  '/join': typeof authJoinRoute
  '/login': typeof authLoginRoute
  '/select-role': typeof authSelectRoleRoute
  '/access-requests/approve': typeof AccessRequestsApproveRoute
  '/access-requests/reject': typeof AccessRequestsRejectRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/profiles': typeof AdminProfilesRoute
  '/admin/users': typeof AdminUsersRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/orderRequests/$key': typeof OrderRequestsKeyRoute
  '/p/$profileSlug': typeof PProfileSlugRoute
  '/p2/$profileSlug': typeof P2ProfileSlugRoute
  '/portfolio/$profileSlug': typeof PortfolioProfileSlugRoute
  '/profiles/claim-confirm': typeof ProfilesClaimConfirmRoute
  '/profiles/verify-email': typeof ProfilesVerifyEmailRoute
  '/admin': typeof AdminIndexRoute
  '/examples/about': typeof appExamplesAboutRoute
  '/examples/analytics': typeof appExamplesAnalyticsRoute
  '/examples/dashboard': typeof appExamplesDashboardRoute
  '/examples/reports': typeof appExamplesReportsRoute
  '/examples/users': typeof appExamplesUsersRoute
  '/brands/$clientId': typeof legacyBrandsClientIdRoute
  '/offers/$token': typeof legacyOffersTokenRoute
  '/programs/$programId': typeof legacyProgramsProgramIdRoute
  '/examples': typeof appExamplesIndexRoute
  '/creators/programs/$programId': typeof legacyCreatorsProgramsProgramIdRouteRouteWithChildren
  '/r/brand/$clientId': typeof appRBrandClientIdRoute
  '/o/$orgSlug/connect': typeof orgOOrgSlugConnectRoute
  '/o/$orgSlug/dashboard': typeof orgOOrgSlugDashboardRoute
  '/o/$orgSlug/earnings': typeof orgOOrgSlugEarningsRoute
  '/o/$orgSlug/marketplace': typeof orgOOrgSlugMarketplaceRoute
  '/o/$orgSlug/members': typeof orgOOrgSlugMembersRoute
  '/o/$orgSlug/onboarding': typeof orgOOrgSlugOnboardingRoute
  '/o/$orgSlug/select-role': typeof orgOOrgSlugSelectRoleRoute
  '/o/$orgSlug/settings': typeof orgOOrgSlugSettingsRoute
  '/o/$orgSlug/toolkit': typeof orgOOrgSlugToolkitRoute
  '/o/$orgSlug': typeof orgOOrgSlugIndexRoute
  '/o/$orgSlug/p/$profileSlug': typeof orgOOrgSlugPProfileSlugRouteRouteWithChildren
  '/o/$orgSlug/projects/$projectId': typeof orgOOrgSlugProjectsProjectIdRouteRoute
  '/creators/programs/$programId/direct': typeof legacyCreatorsProgramsProgramIdDirectRoute
  '/o/$orgSlug/oauth/callback': typeof orgOOrgSlugOauthCallbackRoute
  '/o/$orgSlug/toolkit/preview': typeof orgOOrgSlugToolkitPreviewRoute
  '/o/$orgSlug/user/notifications': typeof orgOOrgSlugUserNotificationsRoute
  '/o/$orgSlug/user/settings': typeof orgOOrgSlugUserSettingsRoute
  '/o/$orgSlug/offers': typeof orgOOrgSlugOffersIndexRoute
  '/o/$orgSlug/profiles': typeof orgOOrgSlugProfilesIndexRoute
  '/o/$orgSlug/projects': typeof orgOOrgSlugProjectsIndexRoute
  '/creators/programs/$programId/content/$contentId': typeof legacyCreatorsProgramsProgramIdContentContentIdRoute
  '/creators/programs/$programId/interaction/$interactionId': typeof legacyCreatorsProgramsProgramIdInteractionInteractionIdRoute
  '/o/$orgSlug/offers/$offerId/boost-product-selection': typeof orgOOrgSlugOffersOfferIdBoostProductSelectionRoute
  '/o/$orgSlug/offers/$offerId/customize-landing': typeof orgOOrgSlugOffersOfferIdCustomizeLandingRoute
  '/o/$orgSlug/offers/$offerId': typeof orgOOrgSlugOffersOfferIdIndexRoute
  '/o/$orgSlug/profiles/$profileSlug': typeof orgOOrgSlugProfilesProfileSlugIndexRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId': typeof orgOOrgSlugPProfileSlugCCampaignIdIndexRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId': typeof orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId': typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRoute
  '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(app)': typeof appRouteRouteWithChildren
  '/(auth)': typeof authRouteRouteWithChildren
  '/(legacy)': typeof legacyRouteRouteWithChildren
  '/(org)': typeof orgRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/connect': typeof ConnectRoute
  '/logout': typeof LogoutRoute
  '/(app)/examples': typeof appExamplesRouteRouteWithChildren
  '/(auth)/join': typeof authJoinRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/select-role': typeof authSelectRoleRoute
  '/access-requests/approve': typeof AccessRequestsApproveRoute
  '/access-requests/reject': typeof AccessRequestsRejectRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/profiles': typeof AdminProfilesRoute
  '/admin/users': typeof AdminUsersRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/orderRequests/$key': typeof OrderRequestsKeyRoute
  '/p/$profileSlug': typeof PProfileSlugRoute
  '/p2/$profileSlug': typeof P2ProfileSlugRoute
  '/portfolio/$profileSlug': typeof PortfolioProfileSlugRoute
  '/profiles/claim-confirm': typeof ProfilesClaimConfirmRoute
  '/profiles/verify-email': typeof ProfilesVerifyEmailRoute
  '/admin/': typeof AdminIndexRoute
  '/(org)/o/$orgSlug': typeof orgOOrgSlugRouteRouteWithChildren
  '/(app)/examples/about': typeof appExamplesAboutRoute
  '/(app)/examples/analytics': typeof appExamplesAnalyticsRoute
  '/(app)/examples/dashboard': typeof appExamplesDashboardRoute
  '/(app)/examples/reports': typeof appExamplesReportsRoute
  '/(app)/examples/users': typeof appExamplesUsersRoute
  '/(legacy)/brands/$clientId': typeof legacyBrandsClientIdRoute
  '/(legacy)/offers/$token': typeof legacyOffersTokenRoute
  '/(legacy)/programs/$programId': typeof legacyProgramsProgramIdRoute
  '/(app)/examples/': typeof appExamplesIndexRoute
  '/(legacy)/creators/programs/$programId': typeof legacyCreatorsProgramsProgramIdRouteRouteWithChildren
  '/(app)/r/brand/$clientId': typeof appRBrandClientIdRoute
  '/(org)/o/$orgSlug/connect': typeof orgOOrgSlugConnectRoute
  '/(org)/o/$orgSlug/dashboard': typeof orgOOrgSlugDashboardRoute
  '/(org)/o/$orgSlug/earnings': typeof orgOOrgSlugEarningsRoute
  '/(org)/o/$orgSlug/marketplace': typeof orgOOrgSlugMarketplaceRoute
  '/(org)/o/$orgSlug/members': typeof orgOOrgSlugMembersRoute
  '/(org)/o/$orgSlug/onboarding': typeof orgOOrgSlugOnboardingRoute
  '/(org)/o/$orgSlug/select-role': typeof orgOOrgSlugSelectRoleRoute
  '/(org)/o/$orgSlug/settings': typeof orgOOrgSlugSettingsRoute
  '/(org)/o/$orgSlug/toolkit': typeof orgOOrgSlugToolkitRoute
  '/(org)/o/$orgSlug/': typeof orgOOrgSlugIndexRoute
  '/(org)/o/$orgSlug/p/$profileSlug': typeof orgOOrgSlugPProfileSlugRouteRouteWithChildren
  '/(org)/o/$orgSlug/profiles/$profileSlug': typeof orgOOrgSlugProfilesProfileSlugRouteRouteWithChildren
  '/(org)/o/$orgSlug/projects/$projectId': typeof orgOOrgSlugProjectsProjectIdRouteRoute
  '/(legacy)/creators/programs/$programId/direct': typeof legacyCreatorsProgramsProgramIdDirectRoute
  '/(org)/o/$orgSlug/oauth/callback': typeof orgOOrgSlugOauthCallbackRoute
  '/(org)/o/$orgSlug/offers/$offerId': typeof orgOOrgSlugOffersOfferIdRouteWithChildren
  '/(org)/o/$orgSlug/toolkit_/preview': typeof orgOOrgSlugToolkitPreviewRoute
  '/(org)/o/$orgSlug/user/notifications': typeof orgOOrgSlugUserNotificationsRoute
  '/(org)/o/$orgSlug/user/settings': typeof orgOOrgSlugUserSettingsRoute
  '/(org)/o/$orgSlug/offers/': typeof orgOOrgSlugOffersIndexRoute
  '/(org)/o/$orgSlug/profiles/': typeof orgOOrgSlugProfilesIndexRoute
  '/(org)/o/$orgSlug/projects/': typeof orgOOrgSlugProjectsIndexRoute
  '/(legacy)/creators/programs/$programId/content/$contentId': typeof legacyCreatorsProgramsProgramIdContentContentIdRoute
  '/(legacy)/creators/programs/$programId/interaction/$interactionId': typeof legacyCreatorsProgramsProgramIdInteractionInteractionIdRoute
  '/(org)/o/$orgSlug/offers/$offerId/boost-product-selection': typeof orgOOrgSlugOffersOfferIdBoostProductSelectionRoute
  '/(org)/o/$orgSlug/offers/$offerId/customize-landing': typeof orgOOrgSlugOffersOfferIdCustomizeLandingRoute
  '/(org)/o/$orgSlug/offers/$offerId/': typeof orgOOrgSlugOffersOfferIdIndexRoute
  '/(org)/o/$orgSlug/profiles/$profileSlug/': typeof orgOOrgSlugProfilesProfileSlugIndexRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId': typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRouteWithChildren
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/': typeof orgOOrgSlugPProfileSlugCCampaignIdIndexRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId': typeof orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId': typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteWithChildren
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId': typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRoute
  '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/': typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/connect'
    | '/logout'
    | '/examples'
    | '/join'
    | '/login'
    | '/select-role'
    | '/access-requests/approve'
    | '/access-requests/reject'
    | '/admin/accounts'
    | '/admin/feature-flags'
    | '/admin/jobs'
    | '/admin/profiles'
    | '/admin/users'
    | '/invitations/accept'
    | '/oauth/callback'
    | '/orderRequests/$key'
    | '/p/$profileSlug'
    | '/p2/$profileSlug'
    | '/portfolio/$profileSlug'
    | '/profiles/claim-confirm'
    | '/profiles/verify-email'
    | '/admin/'
    | '/o/$orgSlug'
    | '/examples/about'
    | '/examples/analytics'
    | '/examples/dashboard'
    | '/examples/reports'
    | '/examples/users'
    | '/brands/$clientId'
    | '/offers/$token'
    | '/programs/$programId'
    | '/examples/'
    | '/creators/programs/$programId'
    | '/r/brand/$clientId'
    | '/o/$orgSlug/connect'
    | '/o/$orgSlug/dashboard'
    | '/o/$orgSlug/earnings'
    | '/o/$orgSlug/marketplace'
    | '/o/$orgSlug/members'
    | '/o/$orgSlug/onboarding'
    | '/o/$orgSlug/select-role'
    | '/o/$orgSlug/settings'
    | '/o/$orgSlug/toolkit'
    | '/o/$orgSlug/'
    | '/o/$orgSlug/p/$profileSlug'
    | '/o/$orgSlug/profiles/$profileSlug'
    | '/o/$orgSlug/projects/$projectId'
    | '/creators/programs/$programId/direct'
    | '/o/$orgSlug/oauth/callback'
    | '/o/$orgSlug/offers/$offerId'
    | '/o/$orgSlug/toolkit/preview'
    | '/o/$orgSlug/user/notifications'
    | '/o/$orgSlug/user/settings'
    | '/o/$orgSlug/offers/'
    | '/o/$orgSlug/profiles/'
    | '/o/$orgSlug/projects/'
    | '/creators/programs/$programId/content/$contentId'
    | '/creators/programs/$programId/interaction/$interactionId'
    | '/o/$orgSlug/offers/$offerId/boost-product-selection'
    | '/o/$orgSlug/offers/$offerId/customize-landing'
    | '/o/$orgSlug/offers/$offerId/'
    | '/o/$orgSlug/profiles/$profileSlug/'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connect'
    | '/logout'
    | '/join'
    | '/login'
    | '/select-role'
    | '/access-requests/approve'
    | '/access-requests/reject'
    | '/admin/accounts'
    | '/admin/feature-flags'
    | '/admin/jobs'
    | '/admin/profiles'
    | '/admin/users'
    | '/invitations/accept'
    | '/oauth/callback'
    | '/orderRequests/$key'
    | '/p/$profileSlug'
    | '/p2/$profileSlug'
    | '/portfolio/$profileSlug'
    | '/profiles/claim-confirm'
    | '/profiles/verify-email'
    | '/admin'
    | '/examples/about'
    | '/examples/analytics'
    | '/examples/dashboard'
    | '/examples/reports'
    | '/examples/users'
    | '/brands/$clientId'
    | '/offers/$token'
    | '/programs/$programId'
    | '/examples'
    | '/creators/programs/$programId'
    | '/r/brand/$clientId'
    | '/o/$orgSlug/connect'
    | '/o/$orgSlug/dashboard'
    | '/o/$orgSlug/earnings'
    | '/o/$orgSlug/marketplace'
    | '/o/$orgSlug/members'
    | '/o/$orgSlug/onboarding'
    | '/o/$orgSlug/select-role'
    | '/o/$orgSlug/settings'
    | '/o/$orgSlug/toolkit'
    | '/o/$orgSlug'
    | '/o/$orgSlug/p/$profileSlug'
    | '/o/$orgSlug/projects/$projectId'
    | '/creators/programs/$programId/direct'
    | '/o/$orgSlug/oauth/callback'
    | '/o/$orgSlug/toolkit/preview'
    | '/o/$orgSlug/user/notifications'
    | '/o/$orgSlug/user/settings'
    | '/o/$orgSlug/offers'
    | '/o/$orgSlug/profiles'
    | '/o/$orgSlug/projects'
    | '/creators/programs/$programId/content/$contentId'
    | '/creators/programs/$programId/interaction/$interactionId'
    | '/o/$orgSlug/offers/$offerId/boost-product-selection'
    | '/o/$orgSlug/offers/$offerId/customize-landing'
    | '/o/$orgSlug/offers/$offerId'
    | '/o/$orgSlug/profiles/$profileSlug'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId'
    | '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/(auth)'
    | '/(legacy)'
    | '/(org)'
    | '/admin'
    | '/connect'
    | '/logout'
    | '/(app)/examples'
    | '/(auth)/join'
    | '/(auth)/login'
    | '/(auth)/select-role'
    | '/access-requests/approve'
    | '/access-requests/reject'
    | '/admin/accounts'
    | '/admin/feature-flags'
    | '/admin/jobs'
    | '/admin/profiles'
    | '/admin/users'
    | '/invitations/accept'
    | '/oauth/callback'
    | '/orderRequests/$key'
    | '/p/$profileSlug'
    | '/p2/$profileSlug'
    | '/portfolio/$profileSlug'
    | '/profiles/claim-confirm'
    | '/profiles/verify-email'
    | '/admin/'
    | '/(org)/o/$orgSlug'
    | '/(app)/examples/about'
    | '/(app)/examples/analytics'
    | '/(app)/examples/dashboard'
    | '/(app)/examples/reports'
    | '/(app)/examples/users'
    | '/(legacy)/brands/$clientId'
    | '/(legacy)/offers/$token'
    | '/(legacy)/programs/$programId'
    | '/(app)/examples/'
    | '/(legacy)/creators/programs/$programId'
    | '/(app)/r/brand/$clientId'
    | '/(org)/o/$orgSlug/connect'
    | '/(org)/o/$orgSlug/dashboard'
    | '/(org)/o/$orgSlug/earnings'
    | '/(org)/o/$orgSlug/marketplace'
    | '/(org)/o/$orgSlug/members'
    | '/(org)/o/$orgSlug/onboarding'
    | '/(org)/o/$orgSlug/select-role'
    | '/(org)/o/$orgSlug/settings'
    | '/(org)/o/$orgSlug/toolkit'
    | '/(org)/o/$orgSlug/'
    | '/(org)/o/$orgSlug/p/$profileSlug'
    | '/(org)/o/$orgSlug/profiles/$profileSlug'
    | '/(org)/o/$orgSlug/projects/$projectId'
    | '/(legacy)/creators/programs/$programId/direct'
    | '/(org)/o/$orgSlug/oauth/callback'
    | '/(org)/o/$orgSlug/offers/$offerId'
    | '/(org)/o/$orgSlug/toolkit_/preview'
    | '/(org)/o/$orgSlug/user/notifications'
    | '/(org)/o/$orgSlug/user/settings'
    | '/(org)/o/$orgSlug/offers/'
    | '/(org)/o/$orgSlug/profiles/'
    | '/(org)/o/$orgSlug/projects/'
    | '/(legacy)/creators/programs/$programId/content/$contentId'
    | '/(legacy)/creators/programs/$programId/interaction/$interactionId'
    | '/(org)/o/$orgSlug/offers/$offerId/boost-product-selection'
    | '/(org)/o/$orgSlug/offers/$offerId/customize-landing'
    | '/(org)/o/$orgSlug/offers/$offerId/'
    | '/(org)/o/$orgSlug/profiles/$profileSlug/'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId'
    | '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appRouteRoute: typeof appRouteRouteWithChildren
  authRouteRoute: typeof authRouteRouteWithChildren
  legacyRouteRoute: typeof legacyRouteRouteWithChildren
  orgRouteRoute: typeof orgRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  ConnectRoute: typeof ConnectRoute
  LogoutRoute: typeof LogoutRoute
  AccessRequestsApproveRoute: typeof AccessRequestsApproveRoute
  AccessRequestsRejectRoute: typeof AccessRequestsRejectRoute
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute
  OauthCallbackRoute: typeof OauthCallbackRoute
  OrderRequestsKeyRoute: typeof OrderRequestsKeyRoute
  PProfileSlugRoute: typeof PProfileSlugRoute
  P2ProfileSlugRoute: typeof P2ProfileSlugRoute
  PortfolioProfileSlugRoute: typeof PortfolioProfileSlugRoute
  ProfilesClaimConfirmRoute: typeof ProfilesClaimConfirmRoute
  ProfilesVerifyEmailRoute: typeof ProfilesVerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(org)': {
      id: '/(org)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof orgRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)': {
      id: '/(legacy)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof legacyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/profiles/verify-email': {
      id: '/profiles/verify-email'
      path: '/profiles/verify-email'
      fullPath: '/profiles/verify-email'
      preLoaderRoute: typeof ProfilesVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiles/claim-confirm': {
      id: '/profiles/claim-confirm'
      path: '/profiles/claim-confirm'
      fullPath: '/profiles/claim-confirm'
      preLoaderRoute: typeof ProfilesClaimConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/$profileSlug': {
      id: '/portfolio/$profileSlug'
      path: '/portfolio/$profileSlug'
      fullPath: '/portfolio/$profileSlug'
      preLoaderRoute: typeof PortfolioProfileSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p2/$profileSlug': {
      id: '/p2/$profileSlug'
      path: '/p2/$profileSlug'
      fullPath: '/p2/$profileSlug'
      preLoaderRoute: typeof P2ProfileSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$profileSlug': {
      id: '/p/$profileSlug'
      path: '/p/$profileSlug'
      fullPath: '/p/$profileSlug'
      preLoaderRoute: typeof PProfileSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orderRequests/$key': {
      id: '/orderRequests/$key'
      path: '/orderRequests/$key'
      fullPath: '/orderRequests/$key'
      preLoaderRoute: typeof OrderRequestsKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/callback': {
      id: '/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof OauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/accept': {
      id: '/invitations/accept'
      path: '/invitations/accept'
      fullPath: '/invitations/accept'
      preLoaderRoute: typeof InvitationsAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/profiles': {
      id: '/admin/profiles'
      path: '/profiles'
      fullPath: '/admin/profiles'
      preLoaderRoute: typeof AdminProfilesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/jobs': {
      id: '/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AdminJobsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/accounts': {
      id: '/admin/accounts'
      path: '/accounts'
      fullPath: '/admin/accounts'
      preLoaderRoute: typeof AdminAccountsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/access-requests/reject': {
      id: '/access-requests/reject'
      path: '/access-requests/reject'
      fullPath: '/access-requests/reject'
      preLoaderRoute: typeof AccessRequestsRejectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-requests/approve': {
      id: '/access-requests/approve'
      path: '/access-requests/approve'
      fullPath: '/access-requests/approve'
      preLoaderRoute: typeof AccessRequestsApproveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/select-role': {
      id: '/(auth)/select-role'
      path: '/select-role'
      fullPath: '/select-role'
      preLoaderRoute: typeof authSelectRoleRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/join': {
      id: '/(auth)/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof authJoinRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(app)/examples': {
      id: '/(app)/examples'
      path: '/examples'
      fullPath: '/examples'
      preLoaderRoute: typeof appExamplesRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/examples/': {
      id: '/(app)/examples/'
      path: '/'
      fullPath: '/examples/'
      preLoaderRoute: typeof appExamplesIndexRouteImport
      parentRoute: typeof appExamplesRouteRoute
    }
    '/(legacy)/programs/$programId': {
      id: '/(legacy)/programs/$programId'
      path: '/programs/$programId'
      fullPath: '/programs/$programId'
      preLoaderRoute: typeof legacyProgramsProgramIdRouteImport
      parentRoute: typeof legacyRouteRoute
    }
    '/(legacy)/offers/$token': {
      id: '/(legacy)/offers/$token'
      path: '/offers/$token'
      fullPath: '/offers/$token'
      preLoaderRoute: typeof legacyOffersTokenRouteImport
      parentRoute: typeof legacyRouteRoute
    }
    '/(legacy)/brands/$clientId': {
      id: '/(legacy)/brands/$clientId'
      path: '/brands/$clientId'
      fullPath: '/brands/$clientId'
      preLoaderRoute: typeof legacyBrandsClientIdRouteImport
      parentRoute: typeof legacyRouteRoute
    }
    '/(app)/examples/users': {
      id: '/(app)/examples/users'
      path: '/users'
      fullPath: '/examples/users'
      preLoaderRoute: typeof appExamplesUsersRouteImport
      parentRoute: typeof appExamplesRouteRoute
    }
    '/(app)/examples/reports': {
      id: '/(app)/examples/reports'
      path: '/reports'
      fullPath: '/examples/reports'
      preLoaderRoute: typeof appExamplesReportsRouteImport
      parentRoute: typeof appExamplesRouteRoute
    }
    '/(app)/examples/dashboard': {
      id: '/(app)/examples/dashboard'
      path: '/dashboard'
      fullPath: '/examples/dashboard'
      preLoaderRoute: typeof appExamplesDashboardRouteImport
      parentRoute: typeof appExamplesRouteRoute
    }
    '/(app)/examples/analytics': {
      id: '/(app)/examples/analytics'
      path: '/analytics'
      fullPath: '/examples/analytics'
      preLoaderRoute: typeof appExamplesAnalyticsRouteImport
      parentRoute: typeof appExamplesRouteRoute
    }
    '/(app)/examples/about': {
      id: '/(app)/examples/about'
      path: '/about'
      fullPath: '/examples/about'
      preLoaderRoute: typeof appExamplesAboutRouteImport
      parentRoute: typeof appExamplesRouteRoute
    }
    '/(org)/o/$orgSlug': {
      id: '/(org)/o/$orgSlug'
      path: '/o/$orgSlug'
      fullPath: '/o/$orgSlug'
      preLoaderRoute: typeof orgOOrgSlugRouteRouteImport
      parentRoute: typeof orgRouteRoute
    }
    '/(org)/o/$orgSlug/': {
      id: '/(org)/o/$orgSlug/'
      path: '/'
      fullPath: '/o/$orgSlug/'
      preLoaderRoute: typeof orgOOrgSlugIndexRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/toolkit': {
      id: '/(org)/o/$orgSlug/toolkit'
      path: '/toolkit'
      fullPath: '/o/$orgSlug/toolkit'
      preLoaderRoute: typeof orgOOrgSlugToolkitRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/settings': {
      id: '/(org)/o/$orgSlug/settings'
      path: '/settings'
      fullPath: '/o/$orgSlug/settings'
      preLoaderRoute: typeof orgOOrgSlugSettingsRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/select-role': {
      id: '/(org)/o/$orgSlug/select-role'
      path: '/select-role'
      fullPath: '/o/$orgSlug/select-role'
      preLoaderRoute: typeof orgOOrgSlugSelectRoleRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/onboarding': {
      id: '/(org)/o/$orgSlug/onboarding'
      path: '/onboarding'
      fullPath: '/o/$orgSlug/onboarding'
      preLoaderRoute: typeof orgOOrgSlugOnboardingRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/members': {
      id: '/(org)/o/$orgSlug/members'
      path: '/members'
      fullPath: '/o/$orgSlug/members'
      preLoaderRoute: typeof orgOOrgSlugMembersRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/marketplace': {
      id: '/(org)/o/$orgSlug/marketplace'
      path: '/marketplace'
      fullPath: '/o/$orgSlug/marketplace'
      preLoaderRoute: typeof orgOOrgSlugMarketplaceRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/earnings': {
      id: '/(org)/o/$orgSlug/earnings'
      path: '/earnings'
      fullPath: '/o/$orgSlug/earnings'
      preLoaderRoute: typeof orgOOrgSlugEarningsRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/dashboard': {
      id: '/(org)/o/$orgSlug/dashboard'
      path: '/dashboard'
      fullPath: '/o/$orgSlug/dashboard'
      preLoaderRoute: typeof orgOOrgSlugDashboardRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/connect': {
      id: '/(org)/o/$orgSlug/connect'
      path: '/connect'
      fullPath: '/o/$orgSlug/connect'
      preLoaderRoute: typeof orgOOrgSlugConnectRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(app)/r/brand/$clientId': {
      id: '/(app)/r/brand/$clientId'
      path: '/r/brand/$clientId'
      fullPath: '/r/brand/$clientId'
      preLoaderRoute: typeof appRBrandClientIdRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(legacy)/creators/programs/$programId': {
      id: '/(legacy)/creators/programs/$programId'
      path: '/creators/programs/$programId'
      fullPath: '/creators/programs/$programId'
      preLoaderRoute: typeof legacyCreatorsProgramsProgramIdRouteRouteImport
      parentRoute: typeof legacyRouteRoute
    }
    '/(org)/o/$orgSlug/projects/': {
      id: '/(org)/o/$orgSlug/projects/'
      path: '/projects'
      fullPath: '/o/$orgSlug/projects/'
      preLoaderRoute: typeof orgOOrgSlugProjectsIndexRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/profiles/': {
      id: '/(org)/o/$orgSlug/profiles/'
      path: '/profiles'
      fullPath: '/o/$orgSlug/profiles/'
      preLoaderRoute: typeof orgOOrgSlugProfilesIndexRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/offers/': {
      id: '/(org)/o/$orgSlug/offers/'
      path: '/offers'
      fullPath: '/o/$orgSlug/offers/'
      preLoaderRoute: typeof orgOOrgSlugOffersIndexRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/user/settings': {
      id: '/(org)/o/$orgSlug/user/settings'
      path: '/user/settings'
      fullPath: '/o/$orgSlug/user/settings'
      preLoaderRoute: typeof orgOOrgSlugUserSettingsRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/user/notifications': {
      id: '/(org)/o/$orgSlug/user/notifications'
      path: '/user/notifications'
      fullPath: '/o/$orgSlug/user/notifications'
      preLoaderRoute: typeof orgOOrgSlugUserNotificationsRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/toolkit_/preview': {
      id: '/(org)/o/$orgSlug/toolkit_/preview'
      path: '/toolkit/preview'
      fullPath: '/o/$orgSlug/toolkit/preview'
      preLoaderRoute: typeof orgOOrgSlugToolkitPreviewRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/offers/$offerId': {
      id: '/(org)/o/$orgSlug/offers/$offerId'
      path: '/offers/$offerId'
      fullPath: '/o/$orgSlug/offers/$offerId'
      preLoaderRoute: typeof orgOOrgSlugOffersOfferIdRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/oauth/callback': {
      id: '/(org)/o/$orgSlug/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/o/$orgSlug/oauth/callback'
      preLoaderRoute: typeof orgOOrgSlugOauthCallbackRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(legacy)/creators/programs/$programId/direct': {
      id: '/(legacy)/creators/programs/$programId/direct'
      path: '/direct'
      fullPath: '/creators/programs/$programId/direct'
      preLoaderRoute: typeof legacyCreatorsProgramsProgramIdDirectRouteImport
      parentRoute: typeof legacyCreatorsProgramsProgramIdRouteRoute
    }
    '/(org)/o/$orgSlug/projects/$projectId': {
      id: '/(org)/o/$orgSlug/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/o/$orgSlug/projects/$projectId'
      preLoaderRoute: typeof orgOOrgSlugProjectsProjectIdRouteRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/profiles/$profileSlug': {
      id: '/(org)/o/$orgSlug/profiles/$profileSlug'
      path: '/profiles/$profileSlug'
      fullPath: '/o/$orgSlug/profiles/$profileSlug'
      preLoaderRoute: typeof orgOOrgSlugProfilesProfileSlugRouteRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug': {
      id: '/(org)/o/$orgSlug/p/$profileSlug'
      path: '/p/$profileSlug'
      fullPath: '/o/$orgSlug/p/$profileSlug'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugRouteRouteImport
      parentRoute: typeof orgOOrgSlugRouteRoute
    }
    '/(org)/o/$orgSlug/profiles/$profileSlug/': {
      id: '/(org)/o/$orgSlug/profiles/$profileSlug/'
      path: '/'
      fullPath: '/o/$orgSlug/profiles/$profileSlug/'
      preLoaderRoute: typeof orgOOrgSlugProfilesProfileSlugIndexRouteImport
      parentRoute: typeof orgOOrgSlugProfilesProfileSlugRouteRoute
    }
    '/(org)/o/$orgSlug/offers/$offerId/': {
      id: '/(org)/o/$orgSlug/offers/$offerId/'
      path: '/'
      fullPath: '/o/$orgSlug/offers/$offerId/'
      preLoaderRoute: typeof orgOOrgSlugOffersOfferIdIndexRouteImport
      parentRoute: typeof orgOOrgSlugOffersOfferIdRoute
    }
    '/(org)/o/$orgSlug/offers/$offerId/customize-landing': {
      id: '/(org)/o/$orgSlug/offers/$offerId/customize-landing'
      path: '/customize-landing'
      fullPath: '/o/$orgSlug/offers/$offerId/customize-landing'
      preLoaderRoute: typeof orgOOrgSlugOffersOfferIdCustomizeLandingRouteImport
      parentRoute: typeof orgOOrgSlugOffersOfferIdRoute
    }
    '/(org)/o/$orgSlug/offers/$offerId/boost-product-selection': {
      id: '/(org)/o/$orgSlug/offers/$offerId/boost-product-selection'
      path: '/boost-product-selection'
      fullPath: '/o/$orgSlug/offers/$offerId/boost-product-selection'
      preLoaderRoute: typeof orgOOrgSlugOffersOfferIdBoostProductSelectionRouteImport
      parentRoute: typeof orgOOrgSlugOffersOfferIdRoute
    }
    '/(legacy)/creators/programs/$programId/interaction/$interactionId': {
      id: '/(legacy)/creators/programs/$programId/interaction/$interactionId'
      path: '/interaction/$interactionId'
      fullPath: '/creators/programs/$programId/interaction/$interactionId'
      preLoaderRoute: typeof legacyCreatorsProgramsProgramIdInteractionInteractionIdRouteImport
      parentRoute: typeof legacyCreatorsProgramsProgramIdRouteRoute
    }
    '/(legacy)/creators/programs/$programId/content/$contentId': {
      id: '/(legacy)/creators/programs/$programId/content/$contentId'
      path: '/content/$contentId'
      fullPath: '/creators/programs/$programId/content/$contentId'
      preLoaderRoute: typeof legacyCreatorsProgramsProgramIdContentContentIdRouteImport
      parentRoute: typeof legacyCreatorsProgramsProgramIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId'
      path: '/c/$campaignId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/'
      path: '/'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdIndexRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId'
      path: '/submit-content/$interactionId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId'
      path: '/sign-brief/$interactionId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId'
      path: '/promo-codes/$interactionId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/promo-codes/$interactionId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId'
      path: '/product-selection/$interactionId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/product-selection/$interactionId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId'
      path: '/customize-landing/$interactionId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/customize-landing/$interactionId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId'
      path: '/custom-task/$stageId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/custom-task/$stageId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId'
      path: '/confirm-info/$interactionId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/confirm-info/$interactionId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId'
      path: '/boost-product-selection/$interactionId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/boost-product-selection/$interactionId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId'
      path: '/affiliate-links/$interactionId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/affiliate-links/$interactionId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/'
      path: '/'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRoute
    }
    '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId': {
      id: '/(org)/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId'
      path: '/$contentReviewId'
      fullPath: '/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId/$contentReviewId'
      preLoaderRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRouteImport
      parentRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRoute
    }
  }
}

interface appExamplesRouteRouteChildren {
  appExamplesAboutRoute: typeof appExamplesAboutRoute
  appExamplesAnalyticsRoute: typeof appExamplesAnalyticsRoute
  appExamplesDashboardRoute: typeof appExamplesDashboardRoute
  appExamplesReportsRoute: typeof appExamplesReportsRoute
  appExamplesUsersRoute: typeof appExamplesUsersRoute
  appExamplesIndexRoute: typeof appExamplesIndexRoute
}

const appExamplesRouteRouteChildren: appExamplesRouteRouteChildren = {
  appExamplesAboutRoute: appExamplesAboutRoute,
  appExamplesAnalyticsRoute: appExamplesAnalyticsRoute,
  appExamplesDashboardRoute: appExamplesDashboardRoute,
  appExamplesReportsRoute: appExamplesReportsRoute,
  appExamplesUsersRoute: appExamplesUsersRoute,
  appExamplesIndexRoute: appExamplesIndexRoute,
}

const appExamplesRouteRouteWithChildren =
  appExamplesRouteRoute._addFileChildren(appExamplesRouteRouteChildren)

interface appRouteRouteChildren {
  appExamplesRouteRoute: typeof appExamplesRouteRouteWithChildren
  appRBrandClientIdRoute: typeof appRBrandClientIdRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appExamplesRouteRoute: appExamplesRouteRouteWithChildren,
  appRBrandClientIdRoute: appRBrandClientIdRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface authRouteRouteChildren {
  authJoinRoute: typeof authJoinRoute
  authLoginRoute: typeof authLoginRoute
  authSelectRoleRoute: typeof authSelectRoleRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authJoinRoute: authJoinRoute,
  authLoginRoute: authLoginRoute,
  authSelectRoleRoute: authSelectRoleRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface legacyCreatorsProgramsProgramIdRouteRouteChildren {
  legacyCreatorsProgramsProgramIdDirectRoute: typeof legacyCreatorsProgramsProgramIdDirectRoute
  legacyCreatorsProgramsProgramIdContentContentIdRoute: typeof legacyCreatorsProgramsProgramIdContentContentIdRoute
  legacyCreatorsProgramsProgramIdInteractionInteractionIdRoute: typeof legacyCreatorsProgramsProgramIdInteractionInteractionIdRoute
}

const legacyCreatorsProgramsProgramIdRouteRouteChildren: legacyCreatorsProgramsProgramIdRouteRouteChildren =
  {
    legacyCreatorsProgramsProgramIdDirectRoute:
      legacyCreatorsProgramsProgramIdDirectRoute,
    legacyCreatorsProgramsProgramIdContentContentIdRoute:
      legacyCreatorsProgramsProgramIdContentContentIdRoute,
    legacyCreatorsProgramsProgramIdInteractionInteractionIdRoute:
      legacyCreatorsProgramsProgramIdInteractionInteractionIdRoute,
  }

const legacyCreatorsProgramsProgramIdRouteRouteWithChildren =
  legacyCreatorsProgramsProgramIdRouteRoute._addFileChildren(
    legacyCreatorsProgramsProgramIdRouteRouteChildren,
  )

interface legacyRouteRouteChildren {
  legacyBrandsClientIdRoute: typeof legacyBrandsClientIdRoute
  legacyOffersTokenRoute: typeof legacyOffersTokenRoute
  legacyProgramsProgramIdRoute: typeof legacyProgramsProgramIdRoute
  legacyCreatorsProgramsProgramIdRouteRoute: typeof legacyCreatorsProgramsProgramIdRouteRouteWithChildren
}

const legacyRouteRouteChildren: legacyRouteRouteChildren = {
  legacyBrandsClientIdRoute: legacyBrandsClientIdRoute,
  legacyOffersTokenRoute: legacyOffersTokenRoute,
  legacyProgramsProgramIdRoute: legacyProgramsProgramIdRoute,
  legacyCreatorsProgramsProgramIdRouteRoute:
    legacyCreatorsProgramsProgramIdRouteRouteWithChildren,
}

const legacyRouteRouteWithChildren = legacyRouteRoute._addFileChildren(
  legacyRouteRouteChildren,
)

interface orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteChildren {
  orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRoute
}

const orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteChildren: orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteChildren =
  {
    orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdContentReviewIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRoute:
      orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdIndexRoute,
  }

const orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteWithChildren =
  orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRoute._addFileChildren(
    orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteChildren,
  )

interface orgOOrgSlugPProfileSlugCCampaignIdRouteRouteChildren {
  orgOOrgSlugPProfileSlugCCampaignIdIndexRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdIndexRoute
  orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRoute
  orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteWithChildren
}

const orgOOrgSlugPProfileSlugCCampaignIdRouteRouteChildren: orgOOrgSlugPProfileSlugCCampaignIdRouteRouteChildren =
  {
    orgOOrgSlugPProfileSlugCCampaignIdIndexRoute:
      orgOOrgSlugPProfileSlugCCampaignIdIndexRoute,
    orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdAffiliateLinksInteractionIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdBoostProductSelectionInteractionIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdConfirmInfoInteractionIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdCustomTaskStageIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdCustomizeLandingInteractionIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdProductSelectionInteractionIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdPromoCodesInteractionIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdSignBriefInteractionIdRoute,
    orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRoute:
      orgOOrgSlugPProfileSlugCCampaignIdSubmitContentInteractionIdRouteWithChildren,
  }

const orgOOrgSlugPProfileSlugCCampaignIdRouteRouteWithChildren =
  orgOOrgSlugPProfileSlugCCampaignIdRouteRoute._addFileChildren(
    orgOOrgSlugPProfileSlugCCampaignIdRouteRouteChildren,
  )

interface orgOOrgSlugPProfileSlugRouteRouteChildren {
  orgOOrgSlugPProfileSlugCCampaignIdRouteRoute: typeof orgOOrgSlugPProfileSlugCCampaignIdRouteRouteWithChildren
}

const orgOOrgSlugPProfileSlugRouteRouteChildren: orgOOrgSlugPProfileSlugRouteRouteChildren =
  {
    orgOOrgSlugPProfileSlugCCampaignIdRouteRoute:
      orgOOrgSlugPProfileSlugCCampaignIdRouteRouteWithChildren,
  }

const orgOOrgSlugPProfileSlugRouteRouteWithChildren =
  orgOOrgSlugPProfileSlugRouteRoute._addFileChildren(
    orgOOrgSlugPProfileSlugRouteRouteChildren,
  )

interface orgOOrgSlugProfilesProfileSlugRouteRouteChildren {
  orgOOrgSlugProfilesProfileSlugIndexRoute: typeof orgOOrgSlugProfilesProfileSlugIndexRoute
}

const orgOOrgSlugProfilesProfileSlugRouteRouteChildren: orgOOrgSlugProfilesProfileSlugRouteRouteChildren =
  {
    orgOOrgSlugProfilesProfileSlugIndexRoute:
      orgOOrgSlugProfilesProfileSlugIndexRoute,
  }

const orgOOrgSlugProfilesProfileSlugRouteRouteWithChildren =
  orgOOrgSlugProfilesProfileSlugRouteRoute._addFileChildren(
    orgOOrgSlugProfilesProfileSlugRouteRouteChildren,
  )

interface orgOOrgSlugOffersOfferIdRouteChildren {
  orgOOrgSlugOffersOfferIdBoostProductSelectionRoute: typeof orgOOrgSlugOffersOfferIdBoostProductSelectionRoute
  orgOOrgSlugOffersOfferIdCustomizeLandingRoute: typeof orgOOrgSlugOffersOfferIdCustomizeLandingRoute
  orgOOrgSlugOffersOfferIdIndexRoute: typeof orgOOrgSlugOffersOfferIdIndexRoute
}

const orgOOrgSlugOffersOfferIdRouteChildren: orgOOrgSlugOffersOfferIdRouteChildren =
  {
    orgOOrgSlugOffersOfferIdBoostProductSelectionRoute:
      orgOOrgSlugOffersOfferIdBoostProductSelectionRoute,
    orgOOrgSlugOffersOfferIdCustomizeLandingRoute:
      orgOOrgSlugOffersOfferIdCustomizeLandingRoute,
    orgOOrgSlugOffersOfferIdIndexRoute: orgOOrgSlugOffersOfferIdIndexRoute,
  }

const orgOOrgSlugOffersOfferIdRouteWithChildren =
  orgOOrgSlugOffersOfferIdRoute._addFileChildren(
    orgOOrgSlugOffersOfferIdRouteChildren,
  )

interface orgOOrgSlugRouteRouteChildren {
  orgOOrgSlugConnectRoute: typeof orgOOrgSlugConnectRoute
  orgOOrgSlugDashboardRoute: typeof orgOOrgSlugDashboardRoute
  orgOOrgSlugEarningsRoute: typeof orgOOrgSlugEarningsRoute
  orgOOrgSlugMarketplaceRoute: typeof orgOOrgSlugMarketplaceRoute
  orgOOrgSlugMembersRoute: typeof orgOOrgSlugMembersRoute
  orgOOrgSlugOnboardingRoute: typeof orgOOrgSlugOnboardingRoute
  orgOOrgSlugSelectRoleRoute: typeof orgOOrgSlugSelectRoleRoute
  orgOOrgSlugSettingsRoute: typeof orgOOrgSlugSettingsRoute
  orgOOrgSlugToolkitRoute: typeof orgOOrgSlugToolkitRoute
  orgOOrgSlugIndexRoute: typeof orgOOrgSlugIndexRoute
  orgOOrgSlugPProfileSlugRouteRoute: typeof orgOOrgSlugPProfileSlugRouteRouteWithChildren
  orgOOrgSlugProfilesProfileSlugRouteRoute: typeof orgOOrgSlugProfilesProfileSlugRouteRouteWithChildren
  orgOOrgSlugProjectsProjectIdRouteRoute: typeof orgOOrgSlugProjectsProjectIdRouteRoute
  orgOOrgSlugOauthCallbackRoute: typeof orgOOrgSlugOauthCallbackRoute
  orgOOrgSlugOffersOfferIdRoute: typeof orgOOrgSlugOffersOfferIdRouteWithChildren
  orgOOrgSlugToolkitPreviewRoute: typeof orgOOrgSlugToolkitPreviewRoute
  orgOOrgSlugUserNotificationsRoute: typeof orgOOrgSlugUserNotificationsRoute
  orgOOrgSlugUserSettingsRoute: typeof orgOOrgSlugUserSettingsRoute
  orgOOrgSlugOffersIndexRoute: typeof orgOOrgSlugOffersIndexRoute
  orgOOrgSlugProfilesIndexRoute: typeof orgOOrgSlugProfilesIndexRoute
  orgOOrgSlugProjectsIndexRoute: typeof orgOOrgSlugProjectsIndexRoute
}

const orgOOrgSlugRouteRouteChildren: orgOOrgSlugRouteRouteChildren = {
  orgOOrgSlugConnectRoute: orgOOrgSlugConnectRoute,
  orgOOrgSlugDashboardRoute: orgOOrgSlugDashboardRoute,
  orgOOrgSlugEarningsRoute: orgOOrgSlugEarningsRoute,
  orgOOrgSlugMarketplaceRoute: orgOOrgSlugMarketplaceRoute,
  orgOOrgSlugMembersRoute: orgOOrgSlugMembersRoute,
  orgOOrgSlugOnboardingRoute: orgOOrgSlugOnboardingRoute,
  orgOOrgSlugSelectRoleRoute: orgOOrgSlugSelectRoleRoute,
  orgOOrgSlugSettingsRoute: orgOOrgSlugSettingsRoute,
  orgOOrgSlugToolkitRoute: orgOOrgSlugToolkitRoute,
  orgOOrgSlugIndexRoute: orgOOrgSlugIndexRoute,
  orgOOrgSlugPProfileSlugRouteRoute:
    orgOOrgSlugPProfileSlugRouteRouteWithChildren,
  orgOOrgSlugProfilesProfileSlugRouteRoute:
    orgOOrgSlugProfilesProfileSlugRouteRouteWithChildren,
  orgOOrgSlugProjectsProjectIdRouteRoute:
    orgOOrgSlugProjectsProjectIdRouteRoute,
  orgOOrgSlugOauthCallbackRoute: orgOOrgSlugOauthCallbackRoute,
  orgOOrgSlugOffersOfferIdRoute: orgOOrgSlugOffersOfferIdRouteWithChildren,
  orgOOrgSlugToolkitPreviewRoute: orgOOrgSlugToolkitPreviewRoute,
  orgOOrgSlugUserNotificationsRoute: orgOOrgSlugUserNotificationsRoute,
  orgOOrgSlugUserSettingsRoute: orgOOrgSlugUserSettingsRoute,
  orgOOrgSlugOffersIndexRoute: orgOOrgSlugOffersIndexRoute,
  orgOOrgSlugProfilesIndexRoute: orgOOrgSlugProfilesIndexRoute,
  orgOOrgSlugProjectsIndexRoute: orgOOrgSlugProjectsIndexRoute,
}

const orgOOrgSlugRouteRouteWithChildren =
  orgOOrgSlugRouteRoute._addFileChildren(orgOOrgSlugRouteRouteChildren)

interface orgRouteRouteChildren {
  orgOOrgSlugRouteRoute: typeof orgOOrgSlugRouteRouteWithChildren
}

const orgRouteRouteChildren: orgRouteRouteChildren = {
  orgOOrgSlugRouteRoute: orgOOrgSlugRouteRouteWithChildren,
}

const orgRouteRouteWithChildren = orgRouteRoute._addFileChildren(
  orgRouteRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminAccountsRoute: typeof AdminAccountsRoute
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute
  AdminJobsRoute: typeof AdminJobsRoute
  AdminProfilesRoute: typeof AdminProfilesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAccountsRoute: AdminAccountsRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminJobsRoute: AdminJobsRoute,
  AdminProfilesRoute: AdminProfilesRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appRouteRoute: appRouteRouteWithChildren,
  authRouteRoute: authRouteRouteWithChildren,
  legacyRouteRoute: legacyRouteRouteWithChildren,
  orgRouteRoute: orgRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  ConnectRoute: ConnectRoute,
  LogoutRoute: LogoutRoute,
  AccessRequestsApproveRoute: AccessRequestsApproveRoute,
  AccessRequestsRejectRoute: AccessRequestsRejectRoute,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
  OauthCallbackRoute: OauthCallbackRoute,
  OrderRequestsKeyRoute: OrderRequestsKeyRoute,
  PProfileSlugRoute: PProfileSlugRoute,
  P2ProfileSlugRoute: P2ProfileSlugRoute,
  PortfolioProfileSlugRoute: PortfolioProfileSlugRoute,
  ProfilesClaimConfirmRoute: ProfilesClaimConfirmRoute,
  ProfilesVerifyEmailRoute: ProfilesVerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
